import { Icon } from '../../../atoms';
import applePay from './../../../../assets/images/apple-pay.png';
import bankTransfer from './../../../../assets/images/bank-transfer.png';
import googlePay from './../../../../assets/images/google-pay.png';
import safeCheckout from './../../../../assets/images/safe-checkout.png';
import sslSecure from './../../../../assets/images/ssl-secure.png';

export const TrustSection = () => {
  return (
    <>
      <div className='mt-8 mb-6 flex flex-col items-center'>
        <div className='relative w-full max-w-lg px-4 sm:px-0'>
          <p className='text-sm font-medium text-gray-700 bg-white px-3 absolute left-1/2 -translate-x-1/2 -top-5 w-36 text-center z-10 rounded'>
            Sicher Bezahlen
          </p>
          <div className='border border-gray-300 rounded-md pt-4'>
            <div className='flex flex-col items-center gap-y-3'>
              <div className='flex items-center justify-center flex-wrap gap-x-4 sm:gap-x-6'>
                <img
                  src={safeCheckout}
                  alt='Sichere Abwicklung Garantiert'
                  className='h-12'
                  title='Sichere Abwicklung Garantiert'
                />
                <img
                  src={sslSecure}
                  alt='SSL Gesicherte Verbindung'
                  className='h-8'
                  title='SSL Gesicherte Verbindung'
                />
                <Icon icon='visa' size={32} aria-label='Visa' />
                <Icon icon='mastercard' size={32} aria-label='Mastercard' />
              </div>

              <div className='flex items-center justify-center flex-wrap gap-x-4 sm:gap-x-6'>
                <img src={bankTransfer} alt='Banküberweisung' className='h-14' title='Banküberweisung' />
                <img src={applePay} alt='Apple Pay' className='h-16' title='Apple Pay' />
                <img src={googlePay} alt='Google Pay' className='h-16' title='Google Pay' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
